import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import {CdkStep, CdkStepper} from '@angular/cdk/stepper';
import {MyEditDialogStepsEnum} from '../../enums/my-edit-dialog-steps.enum';

@Component({
    selector: 'app-projects-stepper',
    templateUrl: './projects-stepper.component.html',
    styleUrls: ['./projects-stepper.component.scss'],
    providers: [{provide: CdkStepper, useExisting: ProjectsStepperComponent}],
})
export class ProjectsStepperComponent extends CdkStepper implements AfterViewInit, OnChanges {

    @Input() public isLinear = false;
    @Input() public showDotsValidation = false;
    @Input() public isNextBtnDisabled = false;
    @Output() public nextBtnClicked: EventEmitter<void> = new EventEmitter();
    @Output() public previousBtnClicked: EventEmitter<void> = new EventEmitter();
    @Output() public dotClicked = new EventEmitter<number>();

    @ViewChild('nextBtn', {static: true}) nextBtnElem: ElementRef;


    @Input() public maxClickableStepIndex = 0;
    @Input() public maxValidatedStepIndex = 0;

    public static getStepHtmlId(step: CdkStep): string {
        return step.content.elementRef
            .nativeElement.parentNode.getAttribute('id');
    }

    public static getStepIndexByHtmlId(step: CdkStep): number {
        const id: string = ProjectsStepperComponent.getStepHtmlId(step);

        if (!MyEditDialogStepsEnum[id]) {
            console.warn('step id was not found or recognized ', id);
        }
        return +MyEditDialogStepsEnum[id];
    }

    public ngAfterViewInit() {
        (this as any)._keyManager = {
            setActiveItem: () => {
                // console.log('stepper setActiveItem called');
            },
            updateActiveItemIndex: () => {
                // console.log('stepper updateActiveItemIndex called');
            },
            updateActiveItem: () => {
                // console.log('stepper updateActiveItem called');
            },
            destroy: () => {
                // console.log('stepper destroy called');
            }
        };
    }

    public ngOnChanges(): void {
        this.linear = this.isLinear;
    }


    public onNextBtnClicked() {
        this.nextBtnClicked.emit();
    }

    public onPreviousBtnClicked() {
        this.previousBtnClicked.emit();
    }

    public onStepperDotClicked(index: number) {
        if (index <= this.maxClickableStepIndex) {
            this.dotClicked.emit(index);
        }
    }

    public stepFormIsInvalid(step: CdkStep): boolean {
        return step?.stepControl?.invalid;
    }

    public allStepsAreValid(): boolean {
        return !(this._steps?.some(step => step.stepControl && step.stepControl.invalid));
    }

    /**
     * set html focus on top next btn
     */
    public focusNextBtn() {
        if (this.nextBtnElem && this.nextBtnElem.nativeElement) {
            this.nextBtnElem.nativeElement.focus();
        }
    }

}
